import type { CheerRow } from "../../shared/types.js";

export interface CheerCount {
  nickname: string;
  days: number;
}

/**
 * 誰來看得最勤。
 *
 * 一人一天一次，所以「幾筆」就是「幾天」——不需要去重。
 * 天數相同時照名字排，否則同分的順序會隨資料庫回傳順序漂移。
 */
/**
 * 監督者看到的參與者名單：**只有名字，沒有天數**。
 *
 * 「誰戳了幾天」是只有本人該知道的事——別的監督者看到「阿明來過 20 天、
 * 小美來過 2 天」很容易讀出不該讀的東西。
 *
 * **照名字排，不照天數排。** 藏掉數字還不夠：順序如果照天數排，第一個就是
 * 戳最多的人，那正是不想讓大家看出來的事。
 *
 * 這是畫面上的體貼，不是機密——`/api/cheers` 對兩種角色回的是同一份資料，
 * 刻意去開 API 的人數得出來。要真的擋住得讓那支端點依角色換形狀。
 */
export function cheerParticipants(cheers: CheerRow[]): string[] {
  return [...new Set(cheers.map(cheer => cheer.nickname))]
    .sort((a, b) => a.localeCompare(b));
}

/** 本人看到的排行：誰來得最勤。 */
export function cheerLeaderboard(cheers: CheerRow[]): CheerCount[] {
  const counts = new Map<string, number>();
  for (const cheer of cheers) {
    counts.set(cheer.nickname, (counts.get(cheer.nickname) || 0) + 1);
  }
  return [...counts.entries()]
    .map(([nickname, days]) => ({ nickname, days }))
    .sort((a, b) => b.days - a.days || a.nickname.localeCompare(b.nickname));
}
